import NAME from "./constants";

export const OPEN_SNACKBAR = NAME + "/OPEN_SNACKBAR";
export const CLOSE_SNACKBAR = NAME + "/CLOSE_SNACKBAR";
